export const degreeChart: {
  [key: string]: {
    [alphabet: string]: string;
  };
} = {
  Ab: {
    Ab: '1',
    A: '1#',
    'A#': '2',
    Bb: '2',
    B: '2#',
    C: '3',
    'C#': '4',
    Db: '4',
    D: '4#',
    'D#': '5',
    Eb: '5',
    E: '5#',
    F: '6',
    'F#': '6#',
    Gb: '6#',
    G: '7',
    'G#': '1',
  },
  A: {
    A: '1',
    'A#': '1#',
    Bb: '1#',
    B: '2',
    C: '2#',
    'C#': '3',
    Db: '3',
    D: '4',
    'D#': '4#',
    Eb: '4#',
    E: '5',
    F: '5#',
    'F#': '6',
    Gb: '6',
    G: '6#',
    'G#': '7',
    Ab: '7',
  },
  'A#': {
    'A#': '1',
    Bb: '1',
    B: '1#',
    C: '2',
    'C#': '2#',
    Db: '2#',
    D: '3',
    'D#': '4',
    Eb: '4',
    E: '4#',
    F: '5',
    'F#': '5#',
    Gb: '5#',
    G: '6',
    'G#': '6#',
    Ab: '6#',
    A: '7',
  },
  Bb: {
    Bb: '1',
    B: '1#',
    C: '2',
    'C#': '2#',
    Db: '2#',
    D: '3',
    'D#': '4',
    Eb: '4',
    E: '4#',
    F: '5',
    'F#': '5#',
    Gb: '5#',
    G: '6',
    'G#': '6#',
    Ab: '6#',
    A: '7',
    'A#': '1',
  },
  B: {
    B: '1',
    C: '1#',
    'C#': '2',
    Db: '2',
    D: '2#',
    'D#': '3',
    Eb: '3',
    E: '4',
    F: '4#',
    'F#': '5',
    Gb: '5',
    G: '5#',
    'G#': '6',
    Ab: '6',
    A: '6#',
    'A#': '7',
    Bb: '7',
  },
  C: {
    C: '1',
    'C#': '1#',
    Db: '1#',
    D: '2',
    'D#': '2#',
    Eb: '2#',
    E: '3',
    F: '4',
    'F#': '4#',
    Gb: '4#',
    G: '5',
    'G#': '5#',
    Ab: '5#',
    A: '6',
    'A#': '6#',
    Bb: '6#',
    B: '7',
  },
  'C#': {
    'C#': '1',
    Db: '1',
    D: '1#',
    'D#': '2',
    Eb: '2',
    E: '2#',
    F: '3',
    'F#': '4',
    Gb: '4',
    G: '4#',
    'G#': '5',
    Ab: '5',
    A: '5#',
    'A#': '6',
    Bb: '6',
    B: '6#',
    C: '7',
  },
  Db: {
    Db: '1',
    D: '1#',
    'D#': '2',
    Eb: '2',
    E: '2#',
    F: '3',
    'F#': '4',
    Gb: '4',
    G: '4#',
    'G#': '5',
    Ab: '5',
    A: '5#',
    'A#': '6',
    Bb: '6',
    B: '6#',
    C: '7',
    'C#': '1',
  },
  D: {
    D: '1',
    'D#': '1#',
    Eb: '1#',
    E: '2',
    F: '2#',
    'F#': '3',
    Gb: '3',
    G: '4',
    'G#': '4#',
    Ab: '4#',
    A: '5',
    'A#': '5#',
    Bb: '5#',
    B: '6',
    C: '6#',
    'C#': '7',
    Db: '7',
  },
  'D#': {
    'D#': '1',
    Eb: '1',
    E: '1#',
    F: '2',
    'F#': '2#',
    Gb: '2#',
    G: '3',
    'G#': '4',
    Ab: '4',
    A: '4#',
    'A#': '5',
    Bb: '5',
    B: '5#',
    C: '6',
    'C#': '6#',
    Db: '6#',
    D: '7',
  },
  Eb: {
    Eb: '1',
    E: '1#',
    F: '2',
    'F#': '2#',
    Gb: '2#',
    G: '3',
    'G#': '4',
    Ab: '4',
    A: '4#',
    'A#': '5',
    Bb: '5',
    B: '5#',
    C: '6',
    'C#': '6#',
    Db: '6#',
    D: '7',
    'D#': '1',
  },
  E: {
    E: '1',
    F: '1#',
    'F#': '2',
    Gb: '2',
    G: '2#',
    'G#': '3',
    Ab: '3',
    A: '4',
    'A#': '4#',
    Bb: '4#',
    B: '5',
    C: '5#',
    'C#': '6',
    Db: '6',
    D: '6#',
    'D#': '7',
    Eb: '7',
  },
  F: {
    F: '1',
    'F#': '1#',
    Gb: '1#',
    G: '2',
    'G#': '2#',
    Ab: '2#',
    A: '3',
    'A#': '4',
    Bb: '4',
    B: '4#',
    C: '5',
    'C#': '5#',
    Db: '5#',
    D: '6',
    'D#': '6#',
    Eb: '6#',
    E: '7',
  },
  'F#': {
    'F#': '1',
    Gb: '1',
    G: '1#',
    'G#': '2',
    Ab: '2',
    A: '2#',
    'A#': '3',
    Bb: '3',
    B: '4',
    C: '4#',
    'C#': '5',
    Db: '5',
    D: '5#',
    'D#': '6',
    Eb: '6',
    E: '6#',
    F: '7',
  },
  Gb: {
    Gb: '1',
    G: '1#',
    'G#': '2',
    Ab: '2',
    A: '2#',
    'A#': '3',
    Bb: '3',
    B: '4',
    C: '4#',
    'C#': '5',
    Db: '5',
    D: '5#',
    'D#': '6',
    Eb: '6',
    E: '6#',
    F: '7',
    'F#': '1',
  },
  G: {
    G: '1',
    'G#': '1#',
    Ab: '1#',
    A: '2',
    'A#': '2#',
    Bb: '2#',
    B: '3',
    C: '4',
    'C#': '4#',
    Db: '4#',
    D: '5',
    'D#': '5#',
    Eb: '5#',
    E: '6',
    F: '6#',
    'F#': '7',
    Gb: '7',
  },
  'G#': {
    'G#': '1',
    Ab: '1',
    A: '1#',
    'A#': '2',
    Bb: '2',
    B: '2#',
    C: '3',
    'C#': '4',
    Db: '4',
    D: '4#',
    'D#': '5',
    Eb: '5',
    E: '5#',
    F: '6',
    'F#': '6#',
    Gb: '6#',
    G: '7',
  },
};
